import styles from "./Note.module.scss";

export function Note(props: { children: React.ReactNode }) {
  return (
    <div className={styles.note} role="note">
      {props.children}
    </div>
  );
}
